export const VideoFormats = {
  MP4: {
    mimeType: "video/mp4",
    extension: "mp4",
  },
  WEBM: { mimeType: "video/webm", extension: "webm" },
};

export const AudioFormats = {
  WEBM: { mimeType: "audio/webm;codecs:opus", extension: "webm" },
  WAV: { mimeType: "audio/wav", extension: "wav" },
  MP4: { mimeType: "audio/mp4", extension: "m4a" },
};

const currentVideoFormat = VideoFormats.WEBM;
const currentAudioFormat = AudioFormats.WEBM;
export const currentTelephonicAudioFormat = AudioFormats.WAV;
export const MediaRecorderConfig = {
  mediaType: currentVideoFormat.mimeType,
  extension: currentVideoFormat.extension,
  audio: true,
  video: true,
  audioBitsPerSecond: 64000,
  videoBitsPerSecond: 512000,
  displaySurface: "exclude",
  monitorTypeSurfaces: "exclude",
  preferCurrentTab: true,
  setAudioOnlyMedia: function () {
    this.mediaType = currentAudioFormat.mimeType;
    this.extension = currentAudioFormat.extension;
    this.video = false;
    return Object.assign({}, MediaRecorderConfig, {
      mediaType: currentAudioFormat.mimeType,
      extension: currentAudioFormat.extension,
      video: false,
    });
  },
  getMediaExtentionConfig: function (ext) {
    const mediaFormat = VideoFormats[`${ext}`.toUpperCase()];
    if (!mediaFormat || !ext) throw new Error(`Invalid Extension "${ext}"`);
    this.mediaType = mediaFormat.mediaType;
    this.extension = mediaFormat.extension;
    return Object.assign({}, MediaRecorderConfig, {
      mediaType: mediaFormat.mimeType,
      extension: mediaFormat.extension,
    });
  },
};
